import {errorMessageFromPayload} from "../utils/errors";
import {SYNC_RESET_DEVICE_SUCCESS} from "../actions/sync";
import {GET_MANEUVER_TYPES, GET_MANEUVER_TYPES_FAILED, GET_MANEUVER_TYPES_SUCCEEDED} from "../actions/maneuverTypes";

const defaultState = {
  list: [],
  error: '',
  loading: false,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case GET_MANEUVER_TYPES: {
      return {
        ...state,
        loading: true,
        error: '',
      };
    }
    case GET_MANEUVER_TYPES_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        list: action.payload,
      };
    }
    case GET_MANEUVER_TYPES_FAILED: {
      return {
        ...state,
        loading: false,
        error: errorMessageFromPayload(action.payload),
      };
    }
    case SYNC_RESET_DEVICE_SUCCESS: {
      return defaultState;
    }
    default:
      return state;
  }
}
